/* eslint-disable jsx-a11y/anchor-is-valid */
import {BaseSyntheticEvent, FC, useState, useEffect, useRef} from 'react'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {Input} from '../../../../components/Input/Input'
import {Button} from '../../../../components/Button/Button'
import {useNavigate, useParams} from 'react-router-dom'
import {DELETE, GET, POST, PUT} from '../../../../services/api'
import {Loading} from '../../../../components/Loading/Loading'
import Swal from 'sweetalert2'
import {ModalDelete} from '../../../../components/Modals/General/ModalDelete/ModalDelete'
import useModals from '../../../../hooks/useModals'
import {ModalWrapper} from '../../../../components/Modals/General/ModalWrapper/ModalWrapper'
import {floatToPrice} from '../../../../functions/price'
import {i18n} from '../../../../translate/i18n'
import uuid from 'react-uuid'
import 'cropperjs/dist/cropper.css'
import {DragDropContext, Droppable, Draggable, DropResult} from 'react-beautiful-dnd'

import {ModalImagemCropped} from '../../../../components/Modals/ImagemCropped/ImagemCropped'
import {removeEspacosEmBranco} from '../../../../utils/formater'
import {BreadCrumbs} from '../../../../components/BreadCrumbs/breadCrumbrs'
import useAdditional from '../../../../hooks/useAdditional'

import styles from './products.module.css'
import {AdditionalListType} from '../../../../context/additionalContext'
import useAuth from '../../../../hooks/useAuth'
import usePluginsSpace from '../../../../hooks/usePluginSpace'
import {ContentModalImageIA, ImageIAResponseType} from '../../../../components/ContentModalImageIA'

type AdditionalType = {
  id: number
  name: string
  checked: boolean
}

type ProductType = {
  id: string
  parent: string
  code: string
  name: string
  description: string
  value: string
  select: string
}

type SelectType = {
  value: string
  select: string
}

type ProductFractionedType = {
  id: string
  code: string
  name: string
  price: number
  status: boolean
}

type ImageType = {
  id: number
  productId: string
  path: string
  imgsuffix: string
  typeimg: string
}

type ImageCreateType = {
  path: string
  productId?: string
  typeimg: string
  order: number
}

type OptionalType = {
  id: number
  name: string
  typeoptional: string
  productId: number
  required: number
  type: string
  max: number
  items: {
    id: number
    product: {
      id: number
      name: string
      code: string
    }
  }[]
}

type FractionedResponseType = {
  id: string
  productFractionalId: string
  productId: string
}

type PluginconfigType = {
  id: number
  name: string
  content: any
  plugintemplateId: number
  plugintypeId: number
}

type TemplateType = {
  id: number
  name: string
  image: string | null
  parameters: string
  plugintypeId: number
  pluginconfig: PluginconfigType
  typeIntegration: string
  able: boolean | null
}

const itemMenu = {
  height: '100%',
  padding: '20px 20px 0',
  alignItems: 'center',
  display: 'flex',
  cursor: 'pointer',
  borderBottom: '4px solid #FFFFFF',
}

const itemMenuActive = {
  ...itemMenu,
  color: '#6993ff',
  borderBottom: '4px solid #6993ff',
}

const itemMenuInactive = {
  ...itemMenu,
  color: 'black',
  borderBottom: '4px solid #CCCCCC',
  marginLeft: 5,
  marginRight: 5,
}

const PageContent: FC = () => {
  const navigate = useNavigate()
  const {id} = useParams()
  const {getAdditionals, getAdditionalByFatherId} = useAdditional()
  const {getLocations, getGmtStore} = usePluginsSpace()

  const {showWrapperModal, closeWrapperModal, showDeleteModal, showImageCropped} = useModals()
  const [action, setAction] = useState<
    | 'createList'
    | 'addProduct'
    | 'associateListAdditional'
    | 'removeListAdditional'
    | 'proposeImage'
  >('createList')
  const {loginInfo} = useAuth()

  const [selectedId, setSelectedId] = useState<number | null>(null)
  const [selecteOptionalIndex, setSelecteOptionalIndex] = useState<number | null>(null)

  const [loading, setLoading] = useState(false)
  const [activeTab, setActiveTab] = useState('#tab1')

  const [type, setType] = useState<string>('product')
  const [name, setName] = useState<string>('')
  const [code, setCode] = useState<string>('')
  const [status, setStatus] = useState<boolean>(true)
  const [description, setDescription] = useState<string>('')

  const [listClassification, setListClassification] = useState<any[]>([])

  const [categoryId, setCategoryId] = useState<string>('0')
  const [categories, setCategories] = useState<any[]>([])
  const [subcategoryId, setSubCategoryId] = useState<string>('0')
  const [subcategories, setSubCategories] = useState<any[]>([])

  const [markId, setMarkId] = useState<string>('0')
  const [locations, setLocations] = useState<any[]>([])
  const [variations, setVariations] = useState<any[]>([])
  const [measurementId, setMeasurementId] = useState<string>('')
  const [order, setOrder] = useState<string>('0')
  const [image, setImage] = useState<File | string | null>(null)
  const [firstStateImage, setFirstStateImage] = useState<File | string | null>(null)
  const [imageId, setImageId] = useState<Number>(0)
  const [imagesProducts, setImagesProducts] = useState<ImageType[]>([])
  const [extraImages, setExtraImages] = useState<FileList>()
  const [extraImagesUrl, setExtraImagesUrl] = useState<ImageType[]>([])
  const [deletedImages, setDeletedImages] = useState<number[]>([])

  const [imageCrop, setImageCrop] = useState<string | null>('')
  const [isCropped, setCropper] = useState<any>(null)

  const [optionals, setOptionals] = useState<any[]>([])
  const [optionalList, setOptionalList] = useState<OptionalType[]>([])

  const [optionalName, setOptionalName] = useState<string>('')
  const [optionalType, setOptionalType] = useState<string>('radio')
  const [optionalMax, setOptionalMax] = useState(0)
  const [optionalRequired, setOptionalRequired] = useState(0)
  const [hasMenu, setHasMenu] = useState(false)

  const [pricing, setPricing] = useState<null | string>('proportional')
  const [qtdProductsFractioned, setQtdProductsFractioned] = useState(1)
  const [showPriceFractioned, setShowPriceFractioned] = useState(false)
  const [showDescriptionFractioned, setShowDescriptionFractioned] = useState(false)
  const [sellAsFractioned, setSellAsFractioned] = useState(false)
  const [productsFractioned, setProductsFractioned] = useState<ProductFractionedType[]>([])
  const [searchProducts, setSearchProducts] = useState<any[]>([])
  const [allProductsFractioned, setAllProductsFractioned] = useState<ProductFractionedType[]>([])
  const [fractions, setFractions] = useState<FractionedResponseType[]>([])

  const [initialHour, setInitialHour] = useState<null | string>(null)
  const [finalHour, setFinalHour] = useState<null | string>(null)

  const canAlertRef = useRef(false)

  const [listAdditionals, setListAdditionals] = useState<AdditionalType[]>([])
  const [listAdditionalsToShow, setListAdditionalsToShow] = useState<AdditionalType[]>([])
  const [selectedAdditional, setSelectedAdditional] = useState<AdditionalType | undefined>()

  const [pluginIA, setPluginIA] = useState('')
  const [imageIaSelected, setImageIaSelected] = useState<ImageIAResponseType>()

  // variaveis para controlar o lazeLoader de alguns dados
  const [lazeLoadOptionals, setLazeLoadOptionals] = useState<boolean>(true)
  const [lazeLoadListOptionals, setLazeLoadListOptionals] = useState<boolean>(true)

  const getLocationsPluginspace = async () => {
    try {
      const res = await getLocations(true, false)
      let _locations: {id: any; name: any}[] = []
      res
        .filter((c: any) => c.type === 'internal')
        .map((item: any) => {
          _locations.push({id: item.id, name: item.name})
        })
      setLocations(_locations)
    } catch (e) {
      console.log(e)
    }
  }

  const getCategories = async () => {
    try {
      const res = await POST(`/classification/filter`, {
        /*O Campo abaixo só é utilizando para o Hotel, 
        nessa rota a troca do pluginType dele ocorre usando esse campo 
        */
        plugintypeId: 7,
      })
      const newList = listClassification
      res.data.map((row: ProductType) => {
        newList.push({
          id: row.id,
          parent: row.parent,
          code: row.code,
          name: row.name,
        })
      })
      setListClassification(newList)
      const cat = newList.filter(function (row) {
        return row.parent === null || row.parent == ''
      })

      const categories = [
        {
          value: '0',
          select: 'Selecione',
          key: -1,
        },
      ]
      cat
        .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))
        .map((row: any, idx) => {
          categories.push({
            value: row.code,
            select: row.name,
            key: idx,
          })
        })
      setCategories(categories)
      setSubCategories([
        {
          value: '0',
          select: 'Selecione',
        },
      ])
    } catch (e) {
      console.log(e)
    }
  }

  const getSubCategories = async (code: string) => {
    const subcategories = [
      {
        value: '0',
        select: 'Selecione',
      },
    ]
    const sub = listClassification.filter(function (row) {
      return row.parent == code
    })
    sub
      .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))
      .map((row: any) => {
        subcategories.push({
          value: row.id,
          select: row.name,
        })
      })
    setSubCategories(subcategories)
  }

  const getProductFractioned = async () => {
    try {
      const resProduct = await GET('/product/fractioned')
      const newList: ProductFractionedType[] = []
      resProduct.data.map((row: any) => {
        newList.push({
          id: row.id,
          name: row.name,
          code: row.code,
          price: row.variations[0].price,
          status: row.status,
        })
      })
      const fractionsFromProduct = fractions
        .map((fract: any) => {
          const prodFind = newList.find((prod) => prod.id === fract.productFractionalId)
          return {
            id: fract.productFractionalId,
            code: prodFind?.code ? prodFind.code : '',
            name: prodFind?.name ? prodFind.name : '',
            price: prodFind?.price ? prodFind.price : 0,
            status: prodFind?.status ? prodFind?.status : false,
          }
        })
        .filter((fract) => fract.code !== '')
      setAllProductsFractioned(newList)
      setProductsFractioned(fractionsFromProduct)
      return fractionsFromProduct
    } catch (e) {
      console.log(e)
      return []
    }
  }

  const getProduct = async () => {
    try {
      await Promise.all([getLocationsPluginspace(), getCategories()])
      const res = await GET(`/product/with-variations-food/${id}`)

      if (res.data) {
        if (res.data[0].classificationId) {
          const cat = listClassification.filter(
            (row) => parseInt(row.id) === parseInt(res.data[0].classificationId)
          )
          if (cat[0] && cat[0].parent) {
            setCategoryId(cat[0].parent)
            getSubCategories(cat[0].parent)
            setSubCategoryId(cat[0].id)
          }
        }
        setMarkId(res.data[0].markId)
        setMeasurementId(res.data[0].measurementUnitId)
        setType(res.data[0].type)
        setName(res.data[0].name)
        setCode(res.data[0].code)
        setDescription(res.data[0].description)
        setStatus(res.data[0].status)
        setOrder(res.data[0].order ?? '0')
        setImagesProducts(res.data[0].images)

        setPricing(res.data[0].typeFractional ? res.data[0].typeFractional : 'proportional')
        setQtdProductsFractioned(
          res.data[0].quantityFractional ? res.data[0].quantityFractional : 1
        )
        setShowPriceFractioned(
          res.data[0].showFractionalPrice ? res.data[0].showFractionalPrice : false
        )
        setShowDescriptionFractioned(
          res.data[0].showFractionalDescription ? res.data[0].showFractionalDescription : false
        )
        setSellAsFractioned(res.data[0].sellAsFractional ? res.data[0].sellAsFractional : false)

        setInitialHour(res.data[0].initialHour ? res.data[0].initialHour : false)
        setFinalHour(res.data[0].finalHour ? res.data[0].finalHour : false)

        if (res.data[0] && res.data[0].fractions && res.data[0].fractions.length > 0) {
          setFractions(res.data[0].fractions)
        }

        let urlProductImage = ''
        const imgProduct = res.data[0].images.find(
          (image: ImageType) => image.typeimg === 'imgsmall'
        )
        if (res.data[0].images.length > 0 && process.env.REACT_APP_AWS_S3_URL) {
          urlProductImage =
            imgProduct.path.substring(7, imgProduct.path.length) + '/' ===
            process.env.REACT_APP_AWS_S3_URL.substring(7, process.env.REACT_APP_AWS_S3_URL.length)
              ? imgProduct.path + '/' + imgProduct.imgsuffix
              : imgProduct.path
        }
        const imagesAdd = res.data[0].images.filter((image: ImageType) => image.typeimg === 'image')
        setExtraImagesUrl(imagesAdd)
        setFirstStateImage(urlProductImage)
        setImage(urlProductImage)
        setImageId(res.data[0].images[0] ? res.data[0].images[0].id : 0)
        setVariations(res.data[0].variations)
      }
    } catch (e) {
      console.log(e)
    }
  }

  const getOptionalList = async () => {
    try {
      setLazeLoadOptionals(true)
      await getOptionals()
      const res = await GET(`/product/${id}/optional-list`)
      if (res.data) {
        const _optionalList = res.data.map((row: any) => ({
          id: row.id,
          name: row.name,
          typeoptional: row.typeoptional,
          productId: row.productId,
          required: row.required,
          type: row.type,
          max: row.max,
          items: row.items,
        }))
        setOptionalList(_optionalList)
      }

      setLazeLoadOptionals(false)
    } catch (e) {
      console.log(e)
      setLazeLoadOptionals(false)
    }
  }
  const orderAddRes = (adds: AdditionalListType[]) => {
    adds.forEach((add) => {
      add.products = add.products.sort((a, b) =>
        a.product.id.toString() === id ? -1 : b.product.id.toString() === id ? 1 : 0
      )
    })
    return adds.sort((a, b) =>
      (a.products[0] ? a.products[0].id : 0) > (b.products[0] ? b.products[0].id : 0)
        ? 1
        : (b.products[0] ? b.products[0].id : 0) > (a.products[0] ? a.products[0].id : 0)
        ? -1
        : 0
    )
  }

  // essa funcao traz todas as listas de adicional e depois rola um filtro.
  const getAdditionalList = async () => {
    try {
      const addRes = await getAdditionals(true)

      let fatherId = id ? parseInt(id) : 0
      console.log(addRes, 'aa')
      if (addRes.success && addRes.data && addRes.data.length > 0) {
        const additionalFilter: AdditionalType[] = orderAddRes(addRes.data).map(
          (add: AdditionalListType) => {
            let checked = false
            if (add.products.find((pd) => parseInt(pd.product.id.toString()) === fatherId)) {
              checked = true
            }
            return {
              id: add.id,
              name: add.name,
              checked,
            }
          }
        )
        const sortByCheck = additionalFilter.sort((a, b) =>
          a.checked < b.checked ? 1 : b.checked < a.checked ? -1 : 0
        )
        setListAdditionals(sortByCheck)
      }
    } catch (e) {
      console.log(e)
    }
  }

  // essa funcao traz todas as listas de adicional do produto que estou editando
  const getAdditionalListByProductParent = async () => {
    try {
      setLazeLoadListOptionals(true)

      let fatherId = id ? parseInt(id) : 0
      const addRes = await getAdditionals(true)

      if (addRes.success && addRes.data && addRes.data.length > 0) {
        const additionalFilter: AdditionalType[] = orderAddRes(addRes.data).map(
          (add: AdditionalListType) => {
            let checked = false
            if (add.products.find((pd) => parseInt(pd.product.id.toString()) === fatherId)) {
              checked = true
            }
            return {
              id: add.id,
              name: add.name,
              checked,
            }
          }
        )
        setListAdditionalsToShow(additionalFilter)
        const sortByCheck = additionalFilter.sort((a, b) =>
          a.checked < b.checked ? 1 : b.checked < a.checked ? -1 : 0
        )
        setListAdditionals(sortByCheck)
      }
      setLazeLoadListOptionals(false)
    } catch (e) {
      setLazeLoadListOptionals(false)
      console.log(e)
    }
  }

  const getOptionals = async () => {
    try {
      const res = await GET(`/product/optionals`)
      if (res.data) {
        setOptionals(res.data)
      }
    } catch (e) {
      console.log(e)
    }
  }

  const editProduct = async () => {
    try {
      if (type === 'product') {
        for (const c of variations) {
          if (c.promotionalPrice > c.price) {
            Swal.fire({
              icon: 'warning',
              title: 'Atenção!',
              text: 'A promoção do produto não pode ser maior que o preço.',
            })
            return
          }
        }
      }
      if (categoryId === '0' || subcategoryId === '0' || !name) {
        canAlertRef.current = true
        Swal.fire({
          icon: 'error',
          title: 'Campos faltantes',
          text: 'Verifique se preencheu todos os campos!',
        })
        return
      } else {
        canAlertRef.current = false
        setLoading(true)
        if (listAdditionals && listAdditionals.length > 0) {
          const saveAdditionals = await POST('optional/associate-father', {
            optionalsId: listAdditionals.filter((add) => add.checked).map((add) => add.id),
            productId: id ? parseInt(id) : 0,
          })
          if (!saveAdditionals.success) {
            Swal.fire({
              icon: 'error',
              title: 'Erro!',
              text: 'Falha ao salvar adicionais.',
            })
            return
          }
        }
        const gmtStore = await getGmtStore()
        const fractionFromProduct =
          productsFractioned && productsFractioned.length > 0
            ? productsFractioned
            : type === 'fractional'
            ? await getProductFractioned()
            : []
        const data = {
          name: removeEspacosEmBranco(name),
          description: description,
          order: parseInt(order),
          code: code ?? '',
          classificationId: parseInt(subcategoryId),
          type: type,
          status: status,
          measurementUnitId: parseInt(measurementId),
          parent: '',
          markId: parseInt(markId),
          typeFractional: type === 'fractional' ? pricing : null,
          quantityFractional: type === 'fractional' ? qtdProductsFractioned : null,
          sellAsFractional: type !== 'fractional' ? sellAsFractioned : false,
          variations: variations.map((c) => ({
            sku: c.sku,
            status: c.status,
            price: c.price,
            promotionalPrice: type === 'product' ? c?.promotionalPrice ?? 0 : 0,
            inventory: c.inventory,
            locationId: c.locationId,
          })),
          fractions: fractionFromProduct.map((prod) => ({
            productFractionalId: prod.id,
          })),
          showFractionalPrice: type === 'fractional' ? showPriceFractioned : false,
          showFractionalDescription: type === 'fractional' ? showDescriptionFractioned : false,
          initialHour: initialHour
            ? initialHour.includes('+')
              ? initialHour.split('+')[0] + gmtStore
              : initialHour.includes('-')
              ? initialHour.split('-')[0] + gmtStore
              : initialHour + gmtStore
            : null,
          finalHour: finalHour
            ? finalHour.includes('+')
              ? finalHour.split('+')[0] + gmtStore
              : finalHour.includes('-')
              ? finalHour.split('-')[0] + gmtStore
              : finalHour + gmtStore
            : null,
        }
        const resProd = await PUT(`/product/${id}`, data)
        const newDeletedImages = Object.assign(deletedImages)
        let dataImages: ImageCreateType[] = []
        if (resProd.success === true) {
          let imageRes = {
            success: false,
            image: '',
          }
          if (image && image !== firstStateImage) {
            let urlImage = imageIaSelected && imageIaSelected.url ? image.toString() : ''
            if (!urlImage) {
              const formData = new FormData()
              formData.append('file', image)
              formData.append('nameImage', `product-${uuid()}.jpg`)
              imageRes = await POST('/upload-images/upload-one', formData)
              urlImage = imageRes.image
            }
            imagesProducts.map((image) => {
              if (image.typeimg !== 'image') {
                deletedImages.push(image.id)
              }
            })
            dataImages = [
              {
                path: urlImage,
                productId: id,
                typeimg: 'imgsmall',
                order: 0,
              },
              {
                path: urlImage,
                productId: id,
                typeimg: 'mainpicture',
                order: 0,
              },
              {
                path: urlImage,
                productId: id,
                typeimg: 'thumbpicture',
                order: 0,
              },
            ]
          } else if (!image) {
            imagesProducts.map((image) => {
              if (image.typeimg !== 'image') {
                deletedImages.push(image.id)
              }
            })
          }
          if (extraImages) {
            await Promise.all(
              Array.from(extraImages).map(async (image, index) => {
                let imageExtraRes = {
                  success: false,
                  image: '',
                }
                const formData = new FormData()
                formData.append('file', image)
                formData.append('nameImage', `product-${uuid()}.jpg`)
                imageExtraRes = await POST('/upload-images/upload-one', formData)
                if (imageExtraRes.success == true) {
                  dataImages.push({
                    path: imageExtraRes.image,
                    productId: id,
                    typeimg: 'image',
                    order: 0,
                  })
                }
              })
            )
          }
          await POST('/productimage/multiple', {
            data: dataImages,
          })
          if (newDeletedImages.length > 0) {
            await POST(`productimage/delete-multiple`, {
              data: newDeletedImages,
            })
          }

          setLoading(false)
          canAlertRef.current = false
          Swal.fire({
            icon: 'success',
            title: 'Produto atualizado',
            text: 'Produto atualizado com sucesso!',
          }).then(() => {
            if (loginInfo.plugintype === 'hospitality') {
              navigate('/product_hospitality')
            } else {
              navigate('/product_food')
            }
          })
        } else {
          canAlertRef.current = true
          setLoading(false)
          Swal.fire({
            icon: 'error',
            title: 'Erro',
            text: 'Erro ao atualizar o produto!',
          })
        }
      }
    } catch (e) {
      canAlertRef.current = true
      setLoading(false)
      console.log(e)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Erro ao atualizar o produto!',
      })
    }
  }

  const verifyIA = async () => {
    const templateRes = await GET('/plugintemplate/ia')
    if (templateRes && templateRes.data) {
      templateRes.data.forEach((template: TemplateType) => {
        if (template.pluginconfig) {
          if (
            template.pluginconfig.content &&
            template.pluginconfig.content.able &&
            template.pluginconfig.content.able !== '0'
          ) {
            setPluginIA(template.pluginconfig.content.modelId)
          }
        }
      })
    }
  }

  async function fetchData() {
    await Promise.all([
      //getProduct -> recupera produto,variacao e imagens, classificacao e location
      getProduct(),
      // recupera a info para saber se possui o chef
      getHasMenu(),
      verifyIA(),
    ])
    setLoading(false)
    // recupera a lista de produtos do produto (lazeLoad)
    getAdditionalListByProductParent()
    // recupera a lista de opcoes (lazeLoad)
    getOptionalList()
  }
  const init = async () => {
    setLoading(true)
    const productFood = localStorage.getItem('product-food-edited-saved')
    if (productFood && JSON.parse(productFood) && JSON.parse(productFood).name) loadLocal()
    else await fetchData()
    setLoading(false)
  }

  useEffect(() => {
    init()
  }, [])

  useEffect(() => {
    return () => {
      if (
        canAlertRef.current &&
        !window.location.pathname.includes(`/product_hospitality/editar/${id}`)
      ) {
        Swal.fire({
          title: 'Sair da página?',
          text: 'Há alterações não salvas que serão perdidas se você sair da página.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sair',
          cancelButtonText: 'Continuar editando',
        }).then((result) => {
          if (!result.isConfirmed) {
            navigate(`/product_food/editar/${id}`)
          } else {
            localStorage.removeItem('product-food-edited-saved')
            canAlertRef.current = false
          }
        })
      } else if (!canAlertRef.current) localStorage.removeItem('product-food-edited-saved')
    }
  }, [window.location.pathname])

  const getHasMenu = async () => {
    try {
      const resMenu = await POST('order-food/has-menu')
      if (resMenu) {
        setHasMenu(resMenu.success)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const addOptionalList = async () => {
    const _optionalName = optionalName
    try {
      if (!optionalName) {
        Swal.fire({
          icon: 'error',
          title: 'Campos faltantes',
          text: 'Verifique se preencheu todos os campos!',
        })
      } else {
        setLoading(true)
        const data = {
          name: optionalName,
          productId: parseInt(id!),
          required: optionalRequired,
          type: optionalType,
          max: optionalMax,
        }
        const res = await POST(`/optional`, data)
        if (res && res.success === false) {
          throw new Error()
        }
        setOptionalName('')
        setOptionalType('')
        setOptionalMax(0)
        setOptionalRequired(0)
        setLoading(false)
        Swal.fire({
          icon: 'success',
          title: 'Lista cadastrada',
          text: 'Lista cadastrada com sucesso!',
        }).then(async () => {
          setLoading(true)
          await getOptionalList()
          setLoading(false)
        })
      }
    } catch (e) {
      setLoading(false)
      if (_optionalName.toLocaleLowerCase() === 'adicionais') {
        Swal.fire({
          icon: 'error',
          title: 'Nome inválido',
          text: 'A palavra adicionais é uma palavra reservada e não pode ser utilizada',
        })
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao salvar lista!',
        })
      }
    }
  }

  const removeOptionalItem = (i: number, j: number) => {
    let _optionalList = [...optionalList]
    if (_optionalList[i]) {
      _optionalList[i].items.splice(j, 1)
      setOptionalList(_optionalList)
    }
  }

  const addOptionalItem = () => {
    let _optionalList = [...optionalList]
    if (selecteOptionalIndex !== null) {
      const items = _optionalList[selecteOptionalIndex].items
      optionals
        .filter((c) => c.checked && c.checked === true)
        .map((c) => {
          if (items.filter((e) => e.product.id === c.id).length === 0) {
            items.push({id: 0, product: {id: c.id, name: c.name, code: c.code}})
          }
        })
    }
    optionals.map((c) => delete c.checked)
  }

  const deleteOptionalList = async () => {
    try {
      setLoading(true)
      await DELETE(`/optional/${selectedId}`)
      Swal.fire({
        icon: 'success',
        title: 'Lista deletada',
        text: 'Deleção realizada com sucesso!',
      }).then(async () => {
        setLoading(true)
        await getOptionalList()
        setLoading(false)
      })
      setLoading(false)
    } catch (e) {
      setLoading(false)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Erro ao deletar lista!',
      }).then(async () => {
        setLoading(true)
        await getOptionalList()
        setLoading(false)
      })
      console.log(e)
    }
  }

  const updateOptionalList = async (index: number) => {
    const _optional = optionalList[index]
    try {
      if (_optional && _optional.id) {
        if (!_optional.name) {
          Swal.fire({
            icon: 'error',
            title: 'Campos faltantes',
            text: 'Verifique se preencheu todos os campos!',
          })
        } else {
          setLoading(true)
          const data = {
            name: _optional.name,
            typeoptional: _optional.typeoptional,
            productId: _optional.productId,
            required: _optional.required,
            type: _optional.type,
            max: _optional.max,
            items: _optional.items.map((c) => parseInt(`${c.product.id}`)),
          }
          const res = await PUT(`/optional/${_optional.id}`, data)
          if (res && res.success === false) {
            throw new Error()
          }
          setLoading(false)
          Swal.fire({
            icon: 'success',
            title: 'Lista atualizada',
            text: 'Lista atualizada com sucesso!',
          }).then(async () => {
            setLoading(true)
            await getOptionalList()
            setLoading(false)
          })
        }
      }
    } catch (e) {
      setLoading(false)
      if (_optional.name.toLocaleLowerCase() === 'adicionais') {
        Swal.fire({
          icon: 'error',
          title: 'Nome inválido',
          text: 'A palavra adicionais é uma palavra reservada e não pode ser utilizada',
        })
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao salvar lista!',
        })
      }
    }
  }

  const removeProductFractioned = (idDeleted: string) => {
    const newProductsFractioned = [...productsFractioned]
    setProductsFractioned(newProductsFractioned.filter((p) => p.id !== idDeleted))
  }
  const addProductFractioned = () => {
    const newProductsFractioned = [...productsFractioned]

    //recupera o produto...

    searchProducts.forEach((product: {label: string; value: string}) => {
      const findProduct = allProductsFractioned.find((pr) => pr.id === product.value)

      if (findProduct && !newProductsFractioned.find((x) => x.code === findProduct.code))
        newProductsFractioned.push(findProduct)
    })
    setProductsFractioned(newProductsFractioned)
  }

  const getCropData = async () => {
    if (isCropped) {
      const file = await fetch(isCropped.getCroppedCanvas().toDataURL())
        .then((res) => res.blob())
        .then((blob) => {
          return new File([blob], 'newAvatar.png', {type: 'image/png'})
        })

      setImage(file)
      setImageCrop('')
    }
  }

  const getImagetoCrop = (e: any) => {
    if (e?.target.files) {
      showImageCropped()
      setImageCrop(URL.createObjectURL(e.target.files[0]))
    }
  }

  const validateTime = (value: string) => {
    if (value) {
      value = value.replaceAll('_', '0')
      const values = value.split(':')
      let val1 = parseInt(values[0]) > 23 ? 23 : values[0]
      let val2 = parseInt(values[0]) > 23 || parseInt(values[1]) > 59 ? 59 : values[1]
      let val3 = parseInt(values[0]) > 23 || parseInt(values[2]) > 59 ? 59 : values[2]
      value = `${val1}:${val2}:${val3}`
    }
    return value
  }

  const loadLocal = async () => {
    const productFood = localStorage.getItem('product-food-edited-saved')
    if (productFood && JSON.parse(productFood)) {
      const jsonProductFood = JSON.parse(productFood)
      setAction(jsonProductFood.action)
      setSelectedId(jsonProductFood.selectedId)
      setSelecteOptionalIndex(jsonProductFood.selecteOptionalIndex)
      setActiveTab(jsonProductFood.activeTab)
      setType(jsonProductFood.type)
      setName(jsonProductFood.name)
      setCode(jsonProductFood.code)
      setStatus(jsonProductFood.status)
      setDescription(jsonProductFood.description)
      setListClassification(jsonProductFood.listClassification)
      setCategoryId(jsonProductFood.categoryId)
      setCategories(jsonProductFood.categories)
      setSubCategoryId(jsonProductFood.subcategoryId)
      setSubCategories(jsonProductFood.subcategories)
      setMarkId(jsonProductFood.markId)
      setLocations(jsonProductFood.locations)
      setVariations(jsonProductFood.variations)
      setMeasurementId(jsonProductFood.measurementId)
      setOrder(jsonProductFood.order)
      setOptionals(jsonProductFood.optionals)
      setOptionalList(jsonProductFood.optionalList)
      setOptionalName(jsonProductFood.optionalName)
      setOptionalType(jsonProductFood.optionalType)
      setOptionalMax(jsonProductFood.optionalMax)
      setOptionalRequired(jsonProductFood.optionalRequired)
      setHasMenu(jsonProductFood.hasMenu)
      setPricing(jsonProductFood.pricing)
      setQtdProductsFractioned(jsonProductFood.qtdProductsFractioned)
      setShowPriceFractioned(jsonProductFood.showPriceFractioned)
      setShowDescriptionFractioned(jsonProductFood.showDescriptionFractioned)
      setSellAsFractioned(jsonProductFood.sellAsFractioned)
      setProductsFractioned(jsonProductFood.productsFractioned)
      setSearchProducts(jsonProductFood.searchProducts)
      setAllProductsFractioned(jsonProductFood.allProductsFractioned)
      setInitialHour(jsonProductFood.initialHour)
      setFinalHour(jsonProductFood.finalHour)
      setListAdditionals(jsonProductFood.listAdditionals)
      setListAdditionalsToShow(jsonProductFood.listAdditionalsToShow)
      if (typeof jsonProductFood.image === 'string') setImage(jsonProductFood.image)
      if (typeof jsonProductFood.firstStateImage === 'string')
        setFirstStateImage(jsonProductFood.firstStateImage)
      setExtraImagesUrl(jsonProductFood.extraImagesUrl)
      if (jsonProductFood.canAlert !== undefined) {
        canAlertRef.current = jsonProductFood.canAlert
      }
    }
    setLazeLoadListOptionals(false)
    setLazeLoadOptionals(false)
  }

  const saveLocal = () => {
    localStorage.setItem(
      'product-food-edited-saved',
      JSON.stringify({
        action,
        selectedId,
        selecteOptionalIndex,
        activeTab,
        type,
        name,
        code,
        status,
        description,
        listClassification,
        categoryId,
        categories,
        subcategoryId,
        subcategories,
        markId,
        locations,
        variations,
        measurementId,
        order,
        optionals,
        optionalList,
        optionalName,
        optionalType,
        optionalMax,
        optionalRequired,
        hasMenu,
        pricing,
        qtdProductsFractioned,
        showPriceFractioned,
        showDescriptionFractioned,
        sellAsFractioned,
        productsFractioned,
        searchProducts,
        allProductsFractioned,
        initialHour,
        finalHour,
        image,
        firstStateImage,
        extraImagesUrl,
        listAdditionals,
        listAdditionalsToShow,
        canAlert: canAlertRef.current,
      })
    )
  }

  useEffect(() => {
    saveLocal()
  }, [
    action,
    selectedId,
    selecteOptionalIndex,
    activeTab,
    type,
    name,
    code,
    status,
    description,
    listClassification,
    categoryId,
    categories,
    subcategoryId,
    subcategories,
    markId,
    locations,
    variations,
    measurementId,
    order,
    optionals,
    optionalList,
    optionalName,
    optionalType,
    optionalMax,
    optionalRequired,
    hasMenu,
    pricing,
    qtdProductsFractioned,
    showPriceFractioned,
    sellAsFractioned,
    productsFractioned,
    searchProducts,
    allProductsFractioned,
    initialHour,
    finalHour,
    image,
    firstStateImage,
    extraImagesUrl,
    listAdditionals,
    listAdditionalsToShow,
  ])

  const handleUnload = (e: BeforeUnloadEvent) => {
    e.preventDefault()
    e.returnValue = true
    localStorage.removeItem('product-food-edited-saved')
  }

  useEffect(() => {
    window.addEventListener('beforeunload', handleUnload)
    return () => window.removeEventListener('beforeunload', handleUnload)
  }, [handleUnload])

  const onDragEnd = async (res: DropResult, list: any, setList: any) => {
    if (!res.destination) return

    setLoading(true)

    const {source, destination} = res
    let copiedItems = [...list]

    const [removed] = copiedItems.splice(source.index, 1)

    copiedItems.splice(destination.index, 0, removed)

    const newCopiedItems = copiedItems.map((list, index) => {
      list.order = index + 1

      return list
    })
    setList(newCopiedItems)

    setLoading(false)
  }
  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='d-flex justify-qnt-between'>
            <div className='w-100'>
              <div className='card'>
                <div className='d-flex' style={{padding: '0 2.25rem', height: 75}}>
                  <div
                    style={activeTab === '#tab1' ? itemMenuActive : itemMenuInactive}
                    onClick={() => setActiveTab('#tab1')}
                  >
                    <span>Informações básicas</span>
                  </div>
                  {type === 'fractional' && (
                    <div
                      style={activeTab === '#tab3' ? itemMenuActive : itemMenuInactive}
                      onClick={async () => {
                        setActiveTab('#tab3')
                        if (!productsFractioned || productsFractioned.length === 0) {
                          setLoading(true)
                          await getProductFractioned()
                          setLoading(false)
                        }
                      }}
                    >
                      <span>Produto fracionado</span>
                    </div>
                  )}
                  <div
                    style={activeTab === '#tab2' ? itemMenuActive : itemMenuInactive}
                    onClick={() => setActiveTab('#tab2')}
                  >
                    <span>Adicionais</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {activeTab === '#tab1' && (
            <>
              <div className='d-flex justify-content-between flex-wrap w-100 gap-5 pb-5'>
                <div style={{flex: 1}}>
                  <div className='card pb-5 h-100'>
                    <div className='card-header py-5'>
                      <h3 className='card-title align-items-start flex-column'>
                        <span className='card-label fw-bold fs-4 mb-1'>Informações básicas</span>
                        <BreadCrumbs />
                      </h3>
                    </div>
                    <div className='px-10 py-5'>
                      <Input
                        inputAttr={{
                          type: 'select',
                        }}
                        label='Tipo'
                        options={[
                          {select: 'Adicional', value: 'optional'},
                          {select: 'Produto', value: 'product'},
                          {select: 'Produto e Adicional', value: 'product_optional'},
                          {select: 'Fracionado', value: 'fractional'},
                        ]}
                        value={type}
                        change={(value: string) => {
                          canAlertRef.current = true
                          setType(value)
                        }}
                      />
                      <Input
                        inputAttr={{
                          type: 'default',
                        }}
                        placeholder='Nome'
                        label='Nome'
                        value={name}
                        change={(value: string) => {
                          canAlertRef.current = true
                          setName(value)
                        }}
                        generateValueIA={
                          pluginIA && pluginIA !== ''
                            ? {
                                modelId: pluginIA,
                                prompt: `Corrija o nome do produto que estou passando colocando as primeiras letras em maiúsculas e o restante normal, não faça para preposições, nem para artigos. Segue o nome do produto: ${name}`,
                                action: 'fix',
                              }
                            : undefined
                        }
                      />
                      <Input
                        inputAttr={{
                          type: 'default',
                        }}
                        placeholder='Código'
                        label='Código'
                        value={code}
                        change={(value: string) => {
                          canAlertRef.current = true
                          setCode(value)
                        }}
                        disabled={hasMenu}
                      />

                      {type !== 'fractional' && (
                        <Input
                          inputAttr={{
                            type: 'checkbox',
                          }}
                          checked={sellAsFractioned}
                          change={(value: boolean) => {
                            canAlertRef.current = true
                            setSellAsFractioned(value)
                          }}
                          label='Vender como fracionado'
                          disabled={hasMenu}
                        />
                      )}

                      <Input
                        inputAttr={{
                          type: 'select',
                        }}
                        label='Status'
                        options={[
                          {select: 'Ativo', value: true},
                          {select: 'Inativo', value: false},
                        ]}
                        value={status}
                        change={(value: boolean) => {
                          canAlertRef.current = true
                          setStatus(value)
                        }}
                      />
                      <Input
                        inputAttr={{
                          type: 'textarea',
                        }}
                        placeholder='Descrição'
                        label='Descrição'
                        value={description}
                        change={(value: string) => {
                          canAlertRef.current = true
                          setDescription(value)
                        }}
                        rows={5}
                        generateValueIA={
                          pluginIA && pluginIA !== ''
                            ? {
                                modelId: pluginIA,
                                prompt:
                                  description === '' || description === name
                                    ? `Crie a descrição do produto com base no nome que estou passando. Segue o nome: ${name}`
                                    : `Corrija a descrição do produto que estou passando. Segue a descrição: ${description}`,
                                action: 'fix',
                              }
                            : undefined
                        }
                      />
                      <Input
                        inputAttr={{
                          type: 'default',
                        }}
                        placeholder={i18n.t(`smart_order.order`)}
                        label={i18n.t(`smart_order.order`)}
                        smalltext='(para exibição no webapp)'
                        value={order}
                        change={(value: string) => {
                          canAlertRef.current = true
                          setOrder(value)
                        }}
                      />
                      <div className='mt-6'>
                        <Input
                          inputAttr={{
                            type: 'time',
                          }}
                          value={initialHour}
                          change={(value: string) => {
                            canAlertRef.current = true
                            setInitialHour(value)
                          }}
                          placeholder='00:00:00'
                          label={`${i18n.t(`smart_order.initial_hour`)}`}
                          blur={(value: string) => setInitialHour(validateTime(value))}
                        />
                      </div>
                      <div className='mt-6'>
                        <Input
                          inputAttr={{
                            type: 'time',
                          }}
                          value={finalHour}
                          change={(value: string) => {
                            canAlertRef.current = true
                            setFinalHour(value)
                          }}
                          placeholder='00:00:00'
                          label={`${i18n.t(`smart_order.final_hour`)}`}
                          blur={(value: string) => setFinalHour(validateTime(value))}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{flex: 1}}>
                  {type === 'fractional' ? (
                    <div className='card pb-5 mb-10'>
                      <div className='card-header py-5'>
                        <h3 className='card-title align-items-start flex-column'>
                          <span className='card-label fw-bold fs-4 mb-1'>Configurações</span>
                        </h3>
                      </div>
                      <div className='px-10 py-5'>
                        <div className='row'>
                          <div className='col-lg-8'>
                            <Input
                              inputAttr={{
                                type: 'select',
                              }}
                              value={pricing}
                              label='Definir precificação'
                              options={[
                                {select: 'Cobrar valor proporcional', value: 'proportional'},
                                {select: 'Cobrar valor maior', value: 'biggest'},
                              ]}
                              change={(value: string | null) => {
                                canAlertRef.current = true
                                setPricing(value)
                              }}
                            />
                            <p
                              style={{
                                fontSize: 12,
                                fontWeight: 300,
                                color: '#333333',
                                marginTop: 4,
                                marginLeft: 2,
                              }}
                            >
                              Cobrar valor proporcional / Cobrar valor maior
                            </p>
                          </div>
                        </div>
                        <div className='row'>
                          <div className='col-lg-8'>
                            <Input
                              inputAttr={{
                                type: 'select',
                              }}
                              value={qtdProductsFractioned}
                              label='Quantidade máxima de produtos'
                              options={[
                                {select: '1', value: 1},
                                {select: '2', value: 2},
                                {select: '3', value: 3},
                                {select: '4', value: 4},
                              ]}
                              change={(value: number) => {
                                canAlertRef.current = true
                                setQtdProductsFractioned(value)
                              }}
                            />
                          </div>
                        </div>
                        <div className='row'>
                          <div className='col-lg-12'>
                            <Input
                              inputAttr={{
                                type: 'checkbox',
                              }}
                              checked={showPriceFractioned}
                              change={(value: boolean) => {
                                canAlertRef.current = true
                                setShowPriceFractioned(value)
                              }}
                              label='Exibir valor do fracionado'
                            />
                          </div>
                        </div>
                        <div className='row'>
                          <div className='col-lg-12'>
                            <Input
                              inputAttr={{
                                type: 'checkbox',
                              }}
                              checked={showDescriptionFractioned}
                              change={(value: boolean) => {
                                canAlertRef.current = true
                                setShowDescriptionFractioned(value)
                              }}
                              label='Exibir descrição do fracionado'
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className='card pb-5 mb-10'>
                      <div className='card-header py-5'>
                        <h3 className='card-title align-items-start flex-column'>
                          <span className='card-label fw-bold fs-4 mb-1'>Preços</span>
                        </h3>
                      </div>
                      <div className='px-10 py-5'>
                        {locations.map((item, i) => (
                          <div key={`location-${i}`} className='p-3 mb-4'>
                            <div className='mb-2 fs-6'>
                              <strong>{item.name}:</strong>
                            </div>
                            <div className='row'>
                              <div className={type === 'product' ? 'col-lg-3' : 'col-lg-4'}>
                                <Input
                                  inputAttr={{
                                    type: 'select',
                                  }}
                                  label='Status'
                                  options={[
                                    {select: 'Ativo', value: true},
                                    {select: 'Inativo', value: false},
                                  ]}
                                  value={
                                    variations.find((c) => c.locationId === item.id)
                                      ? variations.find((c) => c.locationId === item.id).status
                                      : ''
                                  }
                                  change={(value: string) => {
                                    canAlertRef.current = true
                                    let _variations = [...variations]
                                    _variations[
                                      variations.findIndex((c) => c.locationId === item.id)
                                    ].status = value ?? false
                                    setVariations(_variations)
                                  }}
                                />
                              </div>
                              <div className={type === 'product' ? 'col-lg-3' : 'col-lg-4'}>
                                <Input
                                  inputAttr={{
                                    type: 'money',
                                  }}
                                  currency='BRL'
                                  locale='pt-BR'
                                  label='Preço'
                                  value={
                                    variations.find((c) => c.locationId === item.id)
                                      ? variations.find((c) => c.locationId === item.id).price
                                      : ''
                                  }
                                  change={(value: number) => {
                                    canAlertRef.current = true
                                    let _variations = [...variations]
                                    _variations[
                                      variations.findIndex((c) => c.locationId === item.id)
                                    ].price = value ? value : 0
                                    setVariations(_variations)
                                  }}
                                />
                              </div>
                              {type === 'product' && (
                                <div className='col-lg-3'>
                                  <Input
                                    inputAttr={{
                                      type: 'money',
                                    }}
                                    currency='BRL'
                                    locale='pt-BR'
                                    label='Promoção'
                                    value={
                                      variations.find((c) => c.locationId === item.id)
                                        ? variations.find((c) => c.locationId === item.id)
                                            .promotionalPrice
                                        : ''
                                    }
                                    change={(value: number) => {
                                      canAlertRef.current = true
                                      let _variations = [...variations]
                                      _variations[
                                        variations.findIndex((c) => c.locationId === item.id)
                                      ].promotionalPrice = value ? value : 0
                                      setVariations(_variations)
                                    }}
                                  />
                                </div>
                              )}
                              <div className={type === 'product' ? 'col-lg-3' : 'col-lg-4'}>
                                <Input
                                  inputAttr={{
                                    type: 'number',
                                  }}
                                  label='Estoque'
                                  value={
                                    variations.find((c) => c.locationId === item.id)
                                      ? variations.find((c) => c.locationId === item.id).inventory
                                      : 0
                                  }
                                  change={(value: string) => {
                                    canAlertRef.current = true
                                    let _variations = [...variations]
                                    const findLocationVariation = variations.findIndex(
                                      (c) => c.locationId === item.id
                                    )
                                    if (findLocationVariation > -1) {
                                      _variations[
                                        variations.findIndex((c) => c.locationId === item.id)
                                      ].inventory = value ? parseInt(value) : 0
                                      setVariations(_variations)
                                    } else {
                                      _variations.push({
                                        inventory: parseInt(value),
                                        locationId: item.id,
                                        sku: _variations[0].sku,
                                      })
                                      setVariations(_variations)
                                    }
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  <div className='card pb-5 mb-10'>
                    <div className='card-header py-5'>
                      <h3 className='card-title align-items-start flex-column'>
                        <span className='card-label fw-bold fs-4 mb-1'>
                          {i18n.t('smart_order.add_group')}
                        </span>
                      </h3>
                    </div>
                    {lazeLoadListOptionals ? (
                      <>
                        <Loading />
                      </>
                    ) : (
                      <>
                        <div className='px-10 py-5'>
                          {listAdditionals.filter((add) => add.checked).length > 0 ? (
                            <>
                              <p className='m-0 text-dark'>{i18n.t('smart_order.already_add')}</p>
                              <div className='mt-4 d-flex flex-column'>
                                <div
                                  className={`${styles.rowAdditional} ${styles.headerAdditional}`}
                                >
                                  <p>{i18n.t('optional.order')}</p>
                                  <p>{i18n.t('optional.name')}</p>
                                  <p>{i18n.t('general.actions')}</p>
                                </div>
                                <DragDropContext
                                  onDragEnd={(result) =>
                                    onDragEnd(result, listAdditionals, setListAdditionals)
                                  }
                                >
                                  <Droppable droppableId='ROOT' type='group'>
                                    {(provided, snapshot) => (
                                      <div {...provided.droppableProps} ref={provided.innerRef}>
                                        {listAdditionals
                                          .filter((add) => add.checked)
                                          .map((additional, index) => (
                                            <Draggable
                                              key={index.toString()}
                                              draggableId={index.toString()}
                                              index={index}
                                            >
                                              {(provided) => (
                                                <div
                                                  className={`${styles.rowAdditional}`}
                                                  key={index.toString()}
                                                  ref={provided.innerRef}
                                                  {...provided.draggableProps}
                                                  {...provided.dragHandleProps}
                                                >
                                                  <svg
                                                    width='9'
                                                    height='13'
                                                    viewBox='0 0 9 13'
                                                    fill='none'
                                                    xmlns='http://www.w3.org/2000/svg'
                                                    style={{cursor: 'pointer'}}
                                                  >
                                                    <path
                                                      d='M1.09375 11.7812H2.40625V10.4688H1.09375V11.7812ZM1.09375 12.875C0.464844 12.875 0 12.4102 0 11.7812V10.4688C0 9.86719 0.464844 9.375 1.09375 9.375H2.40625C3.00781 9.375 3.5 9.86719 3.5 10.4688V11.7812C3.5 12.4102 3.00781 12.875 2.40625 12.875H1.09375ZM6.34375 11.7812H7.65625V10.4688H6.34375V11.7812ZM6.34375 12.875C5.71484 12.875 5.25 12.4102 5.25 11.7812V10.4688C5.25 9.86719 5.71484 9.375 6.34375 9.375H7.65625C8.25781 9.375 8.75 9.86719 8.75 10.4688V11.7812C8.75 12.4102 8.25781 12.875 7.65625 12.875H6.34375ZM1.09375 6.09375V7.40625H2.40625V6.09375H1.09375ZM0 7.40625V6.09375C0 5.49219 0.464844 5 1.09375 5H2.40625C3.00781 5 3.5 5.49219 3.5 6.09375V7.40625C3.5 8.03516 3.00781 8.5 2.40625 8.5H1.09375C0.464844 8.5 0 8.03516 0 7.40625ZM6.34375 7.40625H7.65625V6.09375H6.34375V7.40625ZM6.34375 8.5C5.71484 8.5 5.25 8.03516 5.25 7.40625V6.09375C5.25 5.49219 5.71484 5 6.34375 5H7.65625C8.25781 5 8.75 5.49219 8.75 6.09375V7.40625C8.75 8.03516 8.25781 8.5 7.65625 8.5H6.34375ZM1.09375 1.71875V3.03125H2.40625V1.71875H1.09375ZM0 3.03125V1.71875C0 1.11719 0.464844 0.625 1.09375 0.625H2.40625C3.00781 0.625 3.5 1.11719 3.5 1.71875V3.03125C3.5 3.66016 3.00781 4.125 2.40625 4.125H1.09375C0.464844 4.125 0 3.66016 0 3.03125ZM6.34375 3.03125H7.65625V1.71875H6.34375V3.03125ZM6.34375 4.125C5.71484 4.125 5.25 3.66016 5.25 3.03125V1.71875C5.25 1.11719 5.71484 0.625 6.34375 0.625H7.65625C8.25781 0.625 8.75 1.11719 8.75 1.71875V3.03125C8.75 3.66016 8.25781 4.125 7.65625 4.125H6.34375Z'
                                                      fill='#6E7586'
                                                    />
                                                  </svg>
                                                  <p>{additional.name}</p>
                                                  <div className='d-flex flex-row align-items-center gap-2 flex-nowrap'>
                                                    <Button
                                                      text={i18n.t('smart_order.remove_add')}
                                                      color='primary'
                                                      size='small'
                                                      horizontalPadding={5}
                                                      btnAttr={{
                                                        type: 'button',
                                                      }}
                                                      click={() => {
                                                        setSelectedAdditional(additional)
                                                        setAction('removeListAdditional')
                                                        showWrapperModal(
                                                          i18n.t('smart_order.remove_add')
                                                        )
                                                      }}
                                                      btnClass='fw-bolder'
                                                      txtClass='text-nowrap'
                                                    />
                                                    <Button
                                                      text={i18n.t('optional.config')}
                                                      color='primary'
                                                      size='small'
                                                      horizontalPadding={5}
                                                      btnAttr={{
                                                        type: 'button',
                                                      }}
                                                      click={() => {}}
                                                      btnClass='fw-bolder'
                                                      txtClass='text-nowrap text-decoration-none'
                                                      blankHref={`${window.location.origin}/optionals/${additional.id}/edit`}
                                                    />
                                                  </div>
                                                </div>
                                              )}
                                            </Draggable>
                                          ))}
                                      </div>
                                    )}
                                  </Droppable>
                                </DragDropContext>
                              </div>
                            </>
                          ) : (
                            <p className='m-0 text-dark'>{i18n.t('smart_order.no_add')}</p>
                          )}
                          <div className='mt-4 d-flex flex-row justify-content-end'>
                            <Button
                              text={i18n.t('smart_order.associate_add')}
                              color='primary'
                              size='small'
                              horizontalPadding={5}
                              btnAttr={{
                                type: 'button',
                              }}
                              click={() => {
                                setAction('associateListAdditional')
                                showWrapperModal(i18n.t('smart_order.associate_add'))
                              }}
                              btnClass='fw-bolder'
                            />
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                  <div className='card pb-5 mb-10'>
                    <div className='card-header py-5'>
                      <h3 className='card-title align-items-start flex-column'>
                        <span className='card-label fw-bold fs-4 mb-1'>Categorias</span>
                      </h3>
                    </div>
                    <div className='px-10 py-5'>
                      <Input
                        inputAttr={{
                          type: 'select',
                        }}
                        label='Categoria'
                        options={categories}
                        value={categoryId}
                        change={(value: string) => {
                          canAlertRef.current = true
                          setCategoryId(value)
                          getSubCategories(value)
                        }}
                      />
                      <Input
                        inputAttr={{
                          type: 'select',
                        }}
                        label='Subcategoria'
                        options={subcategories}
                        value={subcategoryId}
                        change={(value: string) => {
                          canAlertRef.current = true
                          setSubCategoryId(value)
                        }}
                      />
                    </div>
                  </div>
                  <div className='card pb-5'>
                    <div className='card-header py-5'>
                      <h3 className='card-title align-items-start flex-column'>
                        <span className='card-label fw-bold fs-4 mb-1'>Imagens do produto</span>
                      </h3>
                    </div>
                    <div className='d-flex justify-content-center w-100'>
                      <div className='px-10 py-5'>
                        {
                          /*
                    <Input
                      inputAttr={{
                        type: 'image',
                      }}
                      value={image}
                      change={(value: BaseSyntheticEvent) =>
                        setImage(value ? value.target.files[0] : null)
                      }
                    />
                    */
                          <>
                            <Input
                              inputAttr={{
                                type: 'image',
                              }}
                              action={() => {
                                setAction('proposeImage')
                                showWrapperModal(i18n.t('smart_order.create_image_ia'))
                              }}
                              value={image}
                              generateValueIA={
                                pluginIA && pluginIA !== ''
                                  ? {
                                      modelId: pluginIA,
                                      prompt: '',
                                      action: 'create',
                                    }
                                  : undefined
                              }
                              change={(value: BaseSyntheticEvent) => {
                                canAlertRef.current = true
                                setImage(value ? value.target.files[0] : null)
                                if (value) {
                                  getImagetoCrop(value ? value : null)
                                } else {
                                  setImageCrop('')
                                  getImagetoCrop(null)
                                }
                              }}
                            />
                          </>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div className='card px-10 py-4 col-12 mb-5'>
                  <div className='d-flex justify-content-between w-100 '>
                    <Button
                      text={i18n.t(`buttons.back`)}
                      color='info'
                      size='small'
                      horizontalPadding={5}
                      btnAttr={{
                        type: 'button',
                      }}
                      click={() => {
                        if (loginInfo.plugintype === 'hospitality') {
                          navigate('/product_hospitality')
                        } else {
                          navigate('/product_food')
                        }
                      }}
                      btnClass='fw-bolder me-3'
                    />
                    <Button
                      text={i18n.t(`buttons.save`)}
                      color='primary'
                      size='small'
                      horizontalPadding={5}
                      btnAttr={{
                        type: 'button',
                      }}
                      click={() => {
                        canAlertRef.current = false
                        localStorage.removeItem('product-food-edited-saved')
                        editProduct()
                      }}
                      btnClass='fw-bolder'
                    />
                  </div>
                </div>
              </div>
              {/* <div style={{width: 'auto', position: 'fixed', bottom: 40, right: 60}}>
                <Button
                  text='Voltar'
                  color='info'
                  size='small'
                  horizontalPadding={5}
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => {
                    if (loginInfo.plugintype === 'hospitality') {
                      navigate('/product_hospitality')
                    } else {
                      navigate('/product_food')
                    }
                  }}
                  btnClass='fw-bolder me-3'
                />
                <Button
                  text='Salvar'
                  color='primary'
                  size='small'
                  horizontalPadding={5}
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => {
                    canAlertRef.current = false
                    canAlertRef.current = false
                    editProduct()
                  }}
                  btnClass='fw-bolder'
                />
              </div> */}
            </>
          )}

          {activeTab === '#tab2' && (
            <div className='d-flex justify-content-between'>
              {lazeLoadOptionals ? (
                <>
                  <Loading />
                </>
              ) : (
                <>
                  <div className='w-100'>
                    <div className='card pb-5'>
                      <div
                        className='d-flex flex-row align-items-center m-4 p-2 gap-4'
                        style={{
                          border: '1px solid #EB5353',
                          borderRadius: '8px',
                          backgroundColor: '#FDE2E2',
                        }}
                      >
                        <i className='fa fa-exclamation-triangle' style={{color: '#EB5353'}}></i>
                        <p className='m-0'>{i18n.t('smart_order.remove_add_soon')}</p>
                      </div>
                      <div className='card-header py-5'>
                        <h3 className='card-title align-items-start flex-column'>
                          <span className='card-label fw-bold fs-4 mb-1'>Adicionais</span>
                        </h3>
                        <div className='card-toolbar'>
                          <Button
                            text='Criar lista de adicionais'
                            color='primary'
                            iconColor='#FFF'
                            icon='fas fa-plus'
                            size='small'
                            horizontalPadding={6}
                            btnAttr={{
                              type: 'button',
                            }}
                            click={() => {
                              setOptionalName('')
                              setOptionalType('radio')
                              setOptionalMax(0)
                              setOptionalRequired(0)
                              setAction('createList')
                              showWrapperModal('Criar lista de adicionais')
                            }}
                            btnClass='mb-5 fw-bolder'
                          />
                        </div>
                      </div>
                      <div>
                        {optionalList.length === 0 && (
                          <div className='p-10 text-center'>
                            <h3 className='text-gray-600 fs-6 mb-2'>Nenhuma lista encontrada</h3>
                          </div>
                        )}

                        {optionalList.map((optional, i) => (
                          <div
                            key={`option-${i}`}
                            className={'px-10'}
                            style={{borderBottom: '1px solid #eff2f5', paddingBottom: 20}}
                          >
                            <div className='row'>
                              <div className='col-5'>
                                <Input
                                  inputAttr={{
                                    type: 'default',
                                  }}
                                  label='Nome lista'
                                  value={optional.name}
                                  change={(value: string) => {
                                    let _optionals = [...optionalList]
                                    _optionals[i].name = value
                                    setOptionalList(_optionals)
                                  }}
                                />
                              </div>
                              <div className='col-3'>
                                <Input
                                  inputAttr={{
                                    type: 'select',
                                  }}
                                  label='Tipo de Seleção'
                                  options={[
                                    {select: 'Seleção única', value: 'radio'},
                                    {select: 'Seleção múltipla', value: 'checkbox'},
                                    {select: 'Seleção de quantidade', value: 'amount'},
                                  ]}
                                  value={optional.type}
                                  change={(value: string) => {
                                    let _optionals = [...optionalList]
                                    _optionals[i].type = value
                                    setOptionalList(_optionals)
                                  }}
                                />
                              </div>

                              <div className='col-2'>
                                <Input
                                  inputAttr={{
                                    type: 'select',
                                  }}
                                  label='Obrigatório'
                                  options={[
                                    {select: 'Não', value: '0'},
                                    {select: 'Sim', value: '1'},
                                  ]}
                                  value={optional.required}
                                  change={(value: string) => {
                                    let _optionals = [...optionalList]
                                    _optionals[i].required = parseInt(value)
                                    setOptionalList(_optionals)
                                  }}
                                />
                              </div>
                              <div className='col-2'>
                                <Input
                                  inputAttr={{
                                    type: 'select',
                                  }}
                                  label='Máximo'
                                  options={[
                                    {select: 'Sem limte', value: '0'},
                                    {select: '1', value: '1'},
                                    {select: '2', value: '2'},
                                    {select: '3', value: '3'},
                                    {select: '4', value: '4'},
                                    {select: '5', value: '5'},
                                    {select: '6', value: '6'},
                                    {select: '7', value: '7'},
                                    {select: '8', value: '8'},
                                    {select: '9', value: '9'},
                                    {select: '10', value: '10'},
                                  ]}
                                  value={optional.max}
                                  change={(value: string) => {
                                    let _optionals = [...optionalList]
                                    _optionals[i].max = value ? parseInt(value) : 0
                                    setOptionalList(_optionals)
                                  }}
                                />
                              </div>
                            </div>
                            {optional.items.length > 0 && (
                              <div className='row py-5'>
                                <div className='col-12'>
                                  <label>Produtos</label>
                                  {optional.items.map((item, j) => (
                                    <div
                                      key={`optional-${j}`}
                                      className='d-flex'
                                      style={{alignItems: 'center'}}
                                    >
                                      <Input
                                        inputAttr={{
                                          type: 'default',
                                        }}
                                        value={
                                          item.product
                                            ? `${item.product.code} - ${item.product.name}`
                                            : ''
                                        }
                                        disabled={true}
                                      />
                                      <i
                                        className={`fas fa-trash fs-4 mt-6 px-5`}
                                        onClick={() => removeOptionalItem(i, j)}
                                        style={{cursor: 'pointer'}}
                                      />
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                            <div className='d-flex w-100 py-5'>
                              <div className='col-6 d-flex justify-content-start'>
                                <Button
                                  text='Adicionar produto'
                                  color='primary'
                                  size='small'
                                  horizontalPadding={5}
                                  btnAttr={{
                                    type: 'button',
                                  }}
                                  click={() => {
                                    setSelecteOptionalIndex(i)
                                    setAction('addProduct')
                                    showWrapperModal('Adicionar produto')
                                  }}
                                  btnClass='fw-bolder'
                                />
                              </div>
                              <div className='col-6  d-flex justify-content-end'>
                                <Button
                                  text='Salvar lista'
                                  color='primary'
                                  size='small'
                                  horizontalPadding={5}
                                  btnAttr={{
                                    type: 'button',
                                  }}
                                  click={() => {
                                    updateOptionalList(i)
                                  }}
                                  btnClass='fw-bolder'
                                />
                                <Button
                                  text='Excluir lista'
                                  color='danger'
                                  size='small'
                                  horizontalPadding={5}
                                  btnAttr={{
                                    type: 'button',
                                  }}
                                  click={() => {
                                    setSelectedId(optional.id)
                                    showDeleteModal('Excluir produto')
                                  }}
                                  btnClass='fw-bolder ms-3'
                                />
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </>
              )}
              <ModalDelete confirmAction={() => deleteOptionalList()} />
            </div>
          )}

          {activeTab === '#tab3' && (
            <div className='d-flex justify-content-between'>
              <div className='w-100 me-5'>
                <div className='card pb-5'>
                  <div className='card-header py-5'>
                    <h3 className='card-title align-items-start flex-column'>
                      <span className='card-label fw-bold fs-4 mb-1'>Produto fracionado</span>
                    </h3>
                  </div>
                  <span
                    className='py-5'
                    style={{padding: '0 2.25rem', color: '#9FA3B5', fontSize: 12, fontWeight: 400}}
                  >
                    Crie listas com produtos adicionais e defina como eles serão exibidos junto ao
                    produto principal. Também é possivel ordenar os adicionas arrastando eles.
                  </span>
                  <div className='card-footer' style={{borderTop: 'none'}}>
                    <div className='d-flex flex-column justify-content-center align-items-start'>
                      <h2 style={{fontSize: 14, fontWeight: 600}}>Produtos</h2>

                      <DragDropContext
                        onDragEnd={(result) =>
                          onDragEnd(result, productsFractioned, setProductsFractioned)
                        }
                      >
                        <Droppable droppableId='ROOT' type='group'>
                          {(provided, snapshot) => (
                            <div
                              {...provided.droppableProps}
                              ref={provided.innerRef}
                              className='w-100'
                            >
                              {productsFractioned.map((product: any, index: number) => (
                                <Draggable
                                  key={product.id}
                                  draggableId={product.id.toString()}
                                  index={index}
                                >
                                  {(provided) => (
                                    <div
                                      className='form-group mt-5'
                                      key={index}
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                    >
                                      <div className='row' style={{width: '100%'}}>
                                        <div className='col col-lg-5'>
                                          <i className='bi bi-grip-vertical me-2'></i>
                                          <span>
                                            {product.code} - {product.name}{' '}
                                            {!product.status && <span>(Desabilitado)</span>}
                                          </span>
                                        </div>
                                        <div className='col col-lg-4'>
                                          <span>{floatToPrice(product.price)}</span>
                                        </div>
                                        <div className='col col-lg-3'>
                                          <span style={{cursor: 'pointer'}}>
                                            <i
                                              className='fas fa-trash'
                                              onClick={() => removeProductFractioned(product.id)}
                                            />
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </Draggable>
                              ))}
                            </div>
                          )}
                        </Droppable>
                      </DragDropContext>
                    </div>
                    <div className=' d-flex justify-content-end py-6'>
                      <Button
                        text='Adicionar produto'
                        color='primary'
                        size='small'
                        horizontalPadding={5}
                        btnAttr={{
                          type: 'button',
                        }}
                        click={() => {
                          setSearchProducts([])
                          showWrapperModal('Adicionar produto')
                        }}
                        btnClass='fw-bolder'
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {activeTab === '#tab3' ? (
            <ModalWrapper
              confirmAction={() => addProductFractioned()}
              width={60}
              textAction='Adicionar'
              height={30}
              noCloseOverlay={true}
            >
              <div className='d-flex flex-column justify-content-between align-items-center'>
                <div className='flex-grow-1' style={{width: '90%'}}>
                  <Input
                    inputAttr={{
                      type: 'select',
                    }}
                    search
                    isMulti
                    placeholder={'Comece a digitar para procurar um produto'}
                    options={allProductsFractioned
                      .filter(
                        (product) => !productsFractioned.find((el) => el.code === product.code)
                      )
                      .filter((product) => !searchProducts.find((el) => el.value === product.id))
                      .map((product) => ({
                        value: product.id,
                        select: `${product.code} - ${product.name}`,
                      }))}
                    value={searchProducts}
                    change={(selectedProduct: any) => {
                      setSearchProducts(selectedProduct)
                    }}
                  />
                </div>
                <div className='flex-grow-1 mt-4' style={{width: '90%'}}>
                  {searchProducts.map((product: any) => (
                    <div className='d-flex flex-row align-items-center'>
                      <span className={`form-check-label fw-normal text-gray-800 ms-1`}>
                        {product.label}
                      </span>
                      <i
                        style={{marginLeft: '1rem', cursor: 'pointer'}}
                        className='fas fa-times'
                        onClick={() => {
                          setSearchProducts(
                            searchProducts.filter(
                              (productFilter) => product.id !== productFilter.id
                            )
                          )
                        }}
                      ></i>
                    </div>
                  ))}
                </div>
              </div>
            </ModalWrapper>
          ) : (
            <ModalWrapper
              confirmAction={
                action === 'createList'
                  ? () => addOptionalList()
                  : action === 'addProduct'
                  ? () => addOptionalItem()
                  : () => {}
              }
              noCloseOverlay={
                action === 'associateListAdditional' ||
                action === 'removeListAdditional' ||
                action === 'proposeImage'
              }
              noCloseButton={
                action === 'associateListAdditional' ||
                action === 'removeListAdditional' ||
                action === 'proposeImage'
              }
              noAction={
                action === 'associateListAdditional' ||
                action === 'removeListAdditional' ||
                action === 'proposeImage'
              }
              width={70}
              maxWidth
            >
              {action === 'createList' && (
                <div>
                  <div className='row'>
                    <div className='col-12'>
                      <Input
                        inputAttr={{
                          type: 'default',
                        }}
                        label='Nome lista'
                        value={optionalName}
                        change={(value: string) => {
                          setOptionalName(value)
                        }}
                      />
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-4'>
                      <Input
                        inputAttr={{
                          type: 'select',
                        }}
                        label='Tipo de Seleção'
                        options={[
                          {select: 'Seleção única', value: 'radio'},
                          {select: 'Seleção múltipla', value: 'checkbox'},
                          {select: 'Seleção de quantidade', value: 'amount'},
                        ]}
                        value={optionalType}
                        change={(value: string) => {
                          setOptionalType(value)
                        }}
                      />
                    </div>

                    <div className='col-4'>
                      <Input
                        inputAttr={{
                          type: 'select',
                        }}
                        label='Obrigatório'
                        options={[
                          {select: 'Não', value: '0'},
                          {select: 'Sim', value: '1'},
                        ]}
                        value={optionalRequired}
                        change={(value: string) => {
                          setOptionalRequired(parseInt(value))
                        }}
                      />
                    </div>
                    <div className='col-4'>
                      <Input
                        inputAttr={{
                          type: 'select',
                        }}
                        label='Máximo'
                        options={[
                          {select: 'Sem limte', value: '0'},
                          {select: '1', value: '1'},
                          {select: '2', value: '2'},
                          {select: '3', value: '3'},
                          {select: '4', value: '4'},
                          {select: '5', value: '5'},
                          {select: '6', value: '6'},
                          {select: '7', value: '7'},
                          {select: '8', value: '8'},
                          {select: '9', value: '9'},
                          {select: '10', value: '10'},
                        ]}
                        value={optionalMax}
                        change={(value: string) => {
                          setOptionalMax(parseInt(value))
                        }}
                      />
                    </div>
                  </div>
                </div>
              )}
              {action === 'addProduct' && (
                <div
                  className='d-flex justify-content-between'
                  style={{height: 330, overflowY: 'scroll'}}
                >
                  <div className='mx-10 flex-grow-1'>
                    <div className='row'>
                      <div className='col-12'>
                        {optionals.map((item, index) => (
                          <Input
                            key={`optional-product-${index}`}
                            inputAttr={{
                              type: 'checkbox',
                            }}
                            checked={optionals[index].checked === true}
                            change={(value: boolean) => {
                              let _optionals = [...optionals]
                              _optionals[index].checked = value
                              setOptionals(_optionals)
                            }}
                            label={`${item.code} - ${item.name}`}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {action === 'associateListAdditional' && (
                <div className='d-flex flex-column w-100'>
                  <p className='m-0 text-dark mt-4'>
                    {listAdditionals.length > 0
                      ? i18n.t('smart_order.choose_add')
                      : i18n.t('smart_order.no_group_add')}
                  </p>
                  <div className='d-flex flex-column mt-4 pb-4'>
                    {listAdditionalsToShow.map((item, index) => (
                      <div className='d-flex flex-row align-items-center'>
                        <Input
                          inputAttr={{
                            type: 'checkbox',
                          }}
                          label={item.name}
                          checked={item.checked}
                          value={item.checked}
                          change={() => {
                            const newList = [...listAdditionalsToShow]
                            newList.forEach((add) => {
                              if (add.id === item.id) add.checked = !item.checked
                            })
                            setListAdditionals(
                              newList.sort((a, b) =>
                                a.checked < b.checked ? 1 : b.checked < a.checked ? -1 : 0
                              )
                            )
                          }}
                        />
                      </div>
                    ))}
                  </div>
                  <div className='d-flex flex-row justify-content-end'>
                    <Button
                      text={i18n.t(`buttons.close`)}
                      color='light'
                      size='small'
                      horizontalPadding={5}
                      btnAttr={{
                        type: 'button',
                      }}
                      click={() => {
                        closeWrapperModal()
                      }}
                      btnClass='fw-bolder'
                      txtClass='text-nowrap'
                    />
                  </div>
                </div>
              )}
              {action === 'removeListAdditional' && selectedAdditional && (
                <div className='d-flex flex-column w-100 mt-4'>
                  <p className='m-0 text-dark'>
                    {i18n.t('smart_order.remove_add_text').replace('@', selectedAdditional.name)}
                  </p>
                  <div className='d-flex flex-row justify-content-end mt-4'>
                    <Button
                      text={i18n.t('smart_order.remove_add')}
                      color='primary'
                      size='small'
                      horizontalPadding={5}
                      btnAttr={{
                        type: 'button',
                      }}
                      click={() => {
                        const newList = [...listAdditionals]
                        newList.forEach((add) => {
                          if (selectedAdditional && add.id === selectedAdditional.id)
                            add.checked = false
                        })
                        setListAdditionals(
                          newList.sort((a, b) =>
                            a.checked < b.checked ? 1 : b.checked < a.checked ? -1 : 0
                          )
                        )
                        closeWrapperModal()
                      }}
                      btnClass='fw-bolder'
                      txtClass='text-nowrap'
                    />
                  </div>
                </div>
              )}
              {action === 'proposeImage' && (
                <ContentModalImageIA
                  key={'proposeImage'}
                  imageReferenceDefault={image}
                  description={description}
                  setImage={setImage}
                  imageIaSelected={imageIaSelected}
                  setImageIaSelected={setImageIaSelected}
                />
              )}
            </ModalWrapper>
          )}
        </div>
      )}

      <ModalImagemCropped imageCrop={imageCrop} setCropper={setCropper} getCropData={getCropData} />
    </>
  )
}

const EditarProdutos: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {title: 'Produtos', path: 'product_food', isActive: true},
          {title: 'Editar', path: '#', isActive: true},
        ]}
      >
        Editar Produto
      </PageTitle>
      <PageContent />
    </>
  )
}

export {EditarProdutos}
